import apiClient, { getCurrentUserId } from './apiClient';

const fetchPackages = async () => {
  try {
    const response = await apiClient.post('/packages_list', { user_id: getCurrentUserId() });
    return response.data;
  } catch (error) {
    console.error('Error fetching packages:', error);
    throw error;
  }
};

export const deletePackage = async (packageId) => {
  try {
    await apiClient.delete(`/packages/${packageId}`);
  } catch (error) {
    throw new Error(`Failed to delete package with ID ${packageId}: ${error.message}`);
  }
};

export { fetchPackages };
